import React, { useState } from 'react';
import {
  FaCloudUploadAlt,
  FaCloud,
  FaBolt,
  FaShieldAlt,
  FaChartBar,
  FaChevronRight,
  FaLightbulb,
  FaUsers,
  FaRocket,
} from 'react-icons/fa';
import { HiArrowRight, HiShare } from 'react-icons/hi';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { FiLayers } from 'react-icons/fi';
import { FiMessageSquare } from 'react-icons/fi';
import AIdrivenautomation from '../../../assets/img/Blogs/AIdrivenautomation.jpg';
import { RiRobot2Line } from 'react-icons/ri';
import { FiBarChart } from 'react-icons/fi';
import { BiLink } from 'react-icons/bi';

const AerogenixGptBlog = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleShare = async (platform) => {
    const url = window.location.href;
    const text = 'Check out this article about AeroGenix!';

    switch (platform) {
      case 'facebook':
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
          '_blank'
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
          '_blank'
        );
        break;
      case 'linkedin':
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
          '_blank'
        );
        break;
      case 'copy':
        try {
          await navigator.clipboard.writeText(url);
          alert('Link copied to clipboard!');
        } catch (err) {
          alert('Failed to copy link.');
        }
        break;
      default:
        break;
    }
    setActiveDropdown(null);
  };

  return (
    <div className="mx-auto px-4 md:px-24 py-8 w-full max-w-7xl">
      {/* Header */}
      <div className="uppercase tracking-wide text-1xl font-bold text-indigo-500">
        Blog
      </div>
      <h1 className="mt-2 text-4xl font-bold text-gray-900 dark:text-white">
        AeroGenix GPT and AeroGenix AI: Transforming Enterprise AI with AeroGenix
      </h1>

      {/* Share Button */}
      <div className="flex w-full justify-between mt-4 mb-8 items-center">
          <div className="flex flex-wrap gap-4">
               <span className="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-900/20 px-2 py-1 text-sm font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-300/20">
               <RiRobot2Line className="mr-1 h-3 w-3" />
               AI
               </span>
               <span className="inline-flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-2 py-1 text-sm font-medium text-green-700 dark:text-green-300 ring-1 ring-inset ring-green-600/20 dark:ring-green-300/20">
               <FaUsers className="mr-1 h-3 w-3" />
               Enterprise AI
               </span>
               <span className="inline-flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900/20 px-2 py-1 text-sm font-medium text-yellow-800 dark:text-yellow-300 ring-1 ring-inset ring-yellow-600/20 dark:ring-yellow-300/20">
               <FaBolt className="mr-1 h-3 w-3" />
               Automation
               </span>
               <span className="inline-flex items-center rounded-md bg-red-50 dark:bg-red-900/20 px-2 py-1 text-sm font-medium text-red-800 dark:text-red-300 ring-1 ring-inset ring-red-600/20 dark:ring-red-300/20">
               <FaShieldAlt className="mr-1 h-3 w-3" />
               Security & Compliance
               </span>
               <span className="inline-flex items-center rounded-md bg-purple-50 dark:bg-purple-900/20 px-2 py-1 text-sm font-medium text-purple-700 dark:text-purple-300 ring-1 ring-inset ring-purple-600/20 dark:ring-purple-300/20">
               <FaCloud className="mr-1 h-3 w-3" />
               Scalability
               </span>
               <span className="inline-flex items-center rounded-md bg-indigo-50 dark:bg-indigo-900/20 px-2 py-1 text-sm font-medium text-indigo-800 dark:text-indigo-300 ring-1 ring-inset ring-indigo-600/20 dark:ring-indigo-300/20">
               <FaLightbulb className="mr-1 h-3 w-3" />
               Digital Transformation
               </span>
          </div>

        <div className="relative">
          <button
            onClick={() => setActiveDropdown(activeDropdown ? null : 'share')}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Share"
          >
            <HiShare className="h-5 w-5" />
          </button>
          {activeDropdown === 'share' && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
              <button
                onClick={() => handleShare('facebook')}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaFacebook className="mr-2 h-4 w-4" />
                <span>Facebook</span>
              </button>
              <button
                onClick={() => handleShare('twitter')}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaTwitter className="mr-2 h-4 w-4" />
                <span>Twitter</span>
              </button>
              <button
                onClick={() => handleShare('linkedin')}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaLinkedin className="mr-2 h-4 w-4" />
                <span>LinkedIn</span>
              </button>
              <button
                onClick={() => handleShare('copy')}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <BiLink className="mr-2 h-4 w-4" />
                <span>Copy link</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Image Section */}
      <div className="aspect-[16/9] relative rounded-2xl overflow-hidden">
        <img
          src={AIdrivenautomation}
          alt="Person working on tablet"
          className="object-cover w-full h-full"
        />
      </div>

      {/* Blog Content */}

      <div className="mb-8 mt-6">
        <h2 className="text-2xl font-bold mb-4">What is AeroGenix?</h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          AeroGenix is the ultimate enterprise AI platform that enables businesses to build, deploy, and scale AI-powered solutions. Whether it’s intelligent automation, decision support, or AI-driven insights, AeroGenix provides the foundation for seamless AI integration across industries.
        </p>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          With two core capabilities—AeroGenix AI and AeroGenix GPT—AeroGenix empowers enterprises with the ability to deploy autonomous AI agents, generate real-time insights, and optimize complex workflows.
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          AeroGenix AI: The Foundation of Intelligent Enterprise Automation
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          AeroGenix AI serves as the backbone of AI-driven transformation, enabling businesses to:
        </p>
        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4">
          <li>Develop AI-powered automation for customer service, document processing, and business workflows.</li>
          <li>Integrate AI seamlessly with existing enterprise applications, databases, and cloud services.</li>
          <li>Leverage intelligent agents that learn, adapt, and optimize business processes for maximum efficiency.</li>
          <li>Support AI customization through Bring Your Own Data (BYOD) and Bring Your Own Model (BYOM) capabilities.</li>
        </ul>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          AeroGenix AI enables enterprises to build intelligent AI solutions without complex coding, ensuring that companies of all sizes can benefit from AI automation and advanced analytics.
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          AeroGenix GPT: Enterprise-Grade AI for Intelligent Decision-Making
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          AeroGenix GPT takes AI automation a step further by offering a secure, scalable, and high-performance AI model tailored for enterprise needs. Built on advanced Large Language Models (LLMs), AeroGenix GPT delivers:
        </p>
        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4">
          <li>
            AI-driven process automation – Automate knowledge retrieval, report generation, and document processing.
          </li>
          <li>
            Advanced decision support – Provide real-time insights for executives, enabling data-driven strategic planning.
          </li>
          <li>
            API-driven AI inference – Seamlessly integrate AeroGenix GPT into ERP, CRM, and IT systems for intelligent automation.
          </li>
          <li>
            Multi-cloud and hybrid AI deployment – Deploy on-premises, in private clouds, or across AWS, Azure, and GCP.
          </li>
          <li>
            Enterprise-grade security and compliance – Ensuring GDPR, HIPAA, SOC2 compliance with end-to-end encryption.
          </li>
        </ul>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          With AeroGenix GPT, businesses can reduce manual efforts, enhance operational efficiency, and improve productivity—all with the power of AI-driven automation.
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Why Enterprises Choose AeroGenix from AeroAegis?</h2>
        <ol className="list-decimal list-inside text-gray-700 dark:text-gray-300 mb-4">
          <li className="mb-2">
            <strong>AI-Powered Automation Without Complexity</strong>
            <p className="mt-1">
              AeroGenix provides ready-to-use AI automation tools, allowing enterprises to build AI agents without requiring deep technical expertise.
            </p>
          </li>
          <li className="mb-2">
            <strong>Enterprise-Ready AI Security & Compliance</strong>
            <p className="mt-1">
              With built-in encryption, role-based access control, and governance features, AeroGenix ensures that businesses can scale AI solutions while meeting security and regulatory requirements.
            </p>
          </li>
          <li className="mb-2">
            <strong>Scalable AI Infrastructure for Growth</strong>
            <p className="mt-1">
              Whether it's AI-powered customer support, intelligent document processing, or real-time data analysis, AeroGenix adapts to business needs, offering cost-effective AI consumption with token-based pricing.
            </p>
          </li>
          <li className="mb-2">
            <strong>Industry-Specific AI Solutions</strong>
            <p className="mt-1">
              From healthcare and finance to retail and manufacturing, AeroGenix AI and AeroGenix GPT provide industry-tailored AI solutions that drive business innovation and efficiency.
            </p>
          </li>
        </ol>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">The Future of Enterprise AI Starts with AeroGenix</h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          AeroGenix AI and AeroGenix GPT are more than just AI tools—they are the foundation of next-generation enterprise automation. As businesses continue to embrace AI-driven digital transformation, AeroGenix ensures that they stay ahead of the competition with scalable, secure, and intelligent AI solutions.
        </p>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          Discover how AeroGenix can power your AI transformation today!
        </p>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          Get in touch with AeroAegis to learn more.
        </p>
      </div>
    </div>
  );
};

export default AerogenixGptBlog;
